/**
 * 生成模拟数据（用于模糊展示
 * @param {Array} data -引用数据
 * @param {number} count -生成后的总数量，默认为 50 条
 */
export const generateMockData = (data, count = 50) => {
    if (!data || (Array.isArray(data) && data.length === 0)) return [] // 引用数据为空时返回空数组

    const gropNum = data.length // 引用数据的数量
    const repeatTimes = Math.floor(count / gropNum) // 计算可直接复用的次数
    const leftNum = count - (gropNum * repeatTimes) // 计算除可直接复用次数外需额外补充的数量

    // 重复追加数据到数组中
    const newDataArr = []
    for (let i = 0; i < repeatTimes; i++) {
        newDataArr.push(...data)
    }

    // 将剩余数量追加到数组中
    newDataArr.push(...data.slice(0, leftNum))

    return newDataArr
}